export const REMOVE_NOTE = "REMOVE_NOTE"
export const REMOVE_NOTE_SUCCESS = "REMOVE_NOTE_SUCCESS"
export const REMOVE_NOTE_CLEAN = "REMOVE_NOTE_CLEAN"
export const REMOVE_NOTE_ERROR = "REMOVE_NOTE_ERROR"
